import { pipe } from 'fp-ts/function';
import * as RNEA from 'fp-ts/ReadonlyNonEmptyArray';
export * from 'fp-ts/ReadonlyNonEmptyArray';
export var splitAtV = function (as) { return function (n) { return pipe(as, RNEA.splitAt(n)); }; };
